export default __webpack_public_path__ + "static/media/logo.b6c3c068.svg";